const B=a=>{const t=window.theme.locale.rootUrl==="/"?"":window.theme.locale.rootUrl;return`${window.location.origin}${t}/products/${a.handle}`},S=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),A=(a,t)=>{const i=t.getTemplateOptions("product"),b=i.productPageUrl(a),k=t.getPrice?t.getPrice(a):a.price,x=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,C=t.isProductOnSale(x,k),_=a.images,$=_?_.length:0,M=a.featured_image||(_&&_.length>0?_[0]:null);let f="default";$>1&&(f=i.forceHoverGallery?"hover":"gallery");const q=()=>{var v,s,d;let u="";if(C&&(u+='<div class="product-card__badge badge body-extra-small">Sale<span>%</span></div>'),(d=(s=(v=a.metafields)==null?void 0:v.card)==null?void 0:s.badges)!=null&&d.value)for(const c of a.metafields.card.badges.value)u+=`<div class="product-card__badge badge body-extra-small">${c.name}</div>`;return u?`<div class="product-card__badges">${u}</div>`:""},p=()=>{var v,s,d;let u="";if(a.options_with_values){for(const c of a.options_with_values)if(c.name==="Size"){let l="";for(const e of c.values){const r=a.variants.find(o=>o.option1===e||o.option2===e||o.option3===e),g=r?r.available:!1;l+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-option-${S(e)}"
                  name="Size"
                  value="${e}"
                  data-variant-id="${(r==null?void 0:r.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${g?"":"disabled"}
                >
                <label
                  for="${i.context||"card"}-${a.id}-option-${S(e)}"
                  ${g?"":"disabled"}
                  class="quick-add-form__variant-label${g?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${e}</span>
                </label>
              </div>
            `}u+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${i.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${l}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(c.name==="Colour"||c.name==="Color"){let l="";for(let e=0;e<Math.min(c.values.length,3);e++){const r=c.values[e],g=a.variants.find(h=>h.option2===r),o=(s=(v=r.swatch)==null?void 0:v.color)==null?void 0:s.rgba,n=(d=r.swatch)==null?void 0:d.image;l+=`
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-color-${S(r)}"
                  name="Color"
                  value="${r}"
                  data-variant-id="${(g==null?void 0:g.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${r.selected?"checked":""}
                >
                <label
                  for="${i.context||"card"}-${a.id}-color-${S(r)}"
                  class="quick-add-form__variant-label--swatch${n?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${r.product_url||""}"
                  data-swatch
                  data-color="${S(r)}"
                  ${o||n?`style="${o?`background-color: rgba(${o}); --swatch-color: rgba(${o});`:""}${n?`background-image: url(${n});`:""}"`:`style="--swatch-color: var(--swatch-color-${S(r)});"`}
                >
                  <span class="visually-hidden">${r}</span>
                </label>
              `}c.values.length>3&&(l+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${c.values.length-3}</span>
                </div>
              `),u+=`
              <div class="quick-add-form__color-swatches">
                ${i.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${l}
              </div>
            `}}return u},m=()=>C?`
        <span class="product-card__price--sale">${t.formatCurrency(k)}</span>
        <s class="product-card__price--compare">${t.formatCurrency(x)}</s>
      `:`<span class="product-card__price--regular">${t.formatCurrency(k)}</span>`,y=()=>{if(f==="gallery"&&$>1){let u="";for(let v=0;v<Math.min($,3);v++){const s=_[v];u+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${s.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${u}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(f==="hover"&&$>1){let u="";for(let v=0;v<Math.min($,2);v++){const s=_[v];u+=`<img src="${s.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${u}
        </a>
      `}else return`
        <a class="product-card__default-image" href="${b}">
          ${M?`<img src="${M.src}" alt="${a.title}" loading="lazy">`:'<div class="placeholder-image"><p class="site-title">CDP</p></div>'}
        </a>
      `};return`
    <product-card
      data-product-card
      class="product-card"
      data-product-handle="${a.handle}"
      data-template-type="${i.forceHoverGallery&&$>1?"card-hover":"card"}"
    >
      <div class="product-card__media">
        ${q()}
        ${y()}
      </div>
      <div class="product-card__meta-wrapper">
        <div class="product-card__meta">
          <p class="product-card__title">${a.title.split(" - ")[0]}</p>
          <div class="product-card__price">
            ${m()}
          </div>
          <div class="product-card__quick-add-form">
            ${p()}
          </div>
          <button
            class="product-card__quick-add-button"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||b}"
          >
            <svg class="icon icon-bag" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 7.5V5.5C8 3.567 9.567 2 11.5 2C13.433 2 15 3.567 15 5.5V7.5M3 7.5H20V20.5C20 21.328 19.328 22 18.5 22H4.5C3.672 22 3 21.328 3 20.5V7.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </product-card>
  `},P=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),T=(a,t)=>{const i=t.getTemplateOptions("product"),b=i.productPageUrl(a),k=t.getPrice?t.getPrice(a):a.price,x=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,C=a.images,_=C?C.length:0,$=3,M=_<$?_:$;let f="gallery";_<=1&&(f="default"),_===0&&(f="empty"),i.forceHoverGallery&&(f="hover");let q=0,p=!1;if(a.options_with_values)for(const d of a.options_with_values){const c=d.name.toLowerCase();if(c==="colour"||c==="color"){q=d.values.length,p=q>1;break}}const m=()=>{var c,l,e;let d="";if(a.options_with_values){for(const r of a.options_with_values)if(r.name==="Size"){let g="";for(const o of r.values){const n=a.variants.find(w=>w.option1===o||w.option2===o||w.option3===o),h=n?n.available:!1;g+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-option-${P(o)}"
                  name="Size"
                  value="${o}"
                  data-variant-id="${(n==null?void 0:n.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${h?"":"disabled"}
                >
                <label
                  for="${i.context||"card"}-${a.id}-option-${P(o)}"
                  ${h?"":"disabled"}
                  class="quick-add-form__variant-label${h?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${o}</span>
                </label>
              </div>
            `}d+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${i.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${g}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(r.name==="Colour"||r.name==="Color"){let g="";for(let o=0;o<Math.min(r.values.length,3);o++){const n=r.values[o],h=a.variants.find(H=>H.option2===n),w=(l=(c=n.swatch)==null?void 0:c.color)==null?void 0:l.rgba,L=(e=n.swatch)==null?void 0:e.image;g+=`
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-color-${P(n)}"
                  name="Color"
                  value="${n}"
                  data-variant-id="${(h==null?void 0:h.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${n.selected?"checked":""}
                >
                <label
                  for="${i.context||"card"}-${a.id}-color-${P(n)}"
                  class="quick-add-form__variant-label--swatch${L?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${n.product_url||""}"
                  data-swatch
                  data-color="${P(n)}"
                  ${w||L?`style="${w?`background-color: rgba(${w}); --swatch-color: rgba(${w});`:""}${L?`background-image: url(${L});`:""}"`:`style="--swatch-color: var(--swatch-color-${P(n)});"`}
                >
                  <span class="visually-hidden">${n}</span>
                </label>
              `}r.values.length>3&&(g+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${r.values.length-3}</span>
                </div>
              `),d+=`
              <div class="quick-add-form__color-swatches">
                ${i.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${g}
              </div>
            `}}return d},y=()=>{var c,l,e;let d="";if((e=(l=(c=a.metafields)==null?void 0:c.card)==null?void 0:l.badges)!=null&&e.value)for(const r of a.metafields.card.badges.value)d+=`<div class="product-card__badge badge body-extra-small">${r.name}</div>`;return d?`<div class="product-card__badges">${d}</div>`:""},u=()=>x>k?`
        <span class="product-card__price--sale">${t.formatCurrency(k)}</span>
        <s class="product-card__price--compare">${t.formatCurrency(x)}</s>
      `:`<span class="product-card__price--regular">${t.formatCurrency(k)}</span>`,v=()=>{if(f==="gallery"&&_>1){let d="";for(let c=0;c<Math.min(_,$);c++){const l=C[c];d+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${l.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${d}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-pagination body-small" data-pagination>
            <span>1</span><span>/</span><span>${M}</span>
          </div>
        </div>
      `}else if(f==="hover"&&_>1){let d="";for(let c=0;c<Math.min(_,2);c++){const l=C[c];d+=`<img src="${l.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${d}
        </a>
      `}else if(f==="default"){const d=a.featured_image;return`
        <a class="product-card__default-image" href="${b}">
          ${d?`<img src="${d.src}" alt="${a.title}" loading="lazy">`:""}
        </a>
      `}else return'<div class="product-card__gallery-item-image placeholder-svg"></div>'},s=()=>{var l,e,r;const d=(r=(e=(l=a.metafields)==null?void 0:l.card)==null?void 0:e.badges)!=null&&r.value?`
      <div class="product-card__badges--mobile">
        ${y()}
      </div>
    `:"",c=p?`
      <div class="product-card__color-count">
        <span class="body">${q} colours</span>
      </div>
    `:"";return`
      <div class="product-card__meta">
        ${d}
        <p class="product-card__title">${a.title.split(" - ")[0]}</p>
        <div class="product-card__price">
          ${u()}
        </div>
        <div class="product-card__quick-add-form">
          ${m()}
        </div>
        ${c}
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${y()}
        ${v()}
        <button
          class="product-card__quick-add-button"
          type="button"
          data-quick-add-modal-toggle
          data-product-url="${a.url||b}"
        >
          <svg class="icon icon-plus" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      ${s()}
    </product-card>
  `},z=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),O=(a,t)=>{const i=t.getTemplateOptions("product"),b=i.productPageUrl(a),k=t.getPrice?t.getPrice(a):a.price,x=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,C=x>k,_=a.images,$=_?_.length:0,M=3;let f="hover";$<=1&&(f="default"),i.forceGallery&&(f="gallery");const q=()=>{var d,c,l;let s="";if(a.options_with_values){for(const e of a.options_with_values)if(e.name==="Size"){let r="";for(const g of e.values){const o=(g==null?void 0:g.name)||g,n=a.variants.find(w=>w.option1===o||w.option2===o||w.option3===o),h=n?n.available:!1;r+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-option-${z(o)}"
                  name="Size"
                  value="${o}"
                  data-variant-id="${(n==null?void 0:n.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${h?"":"disabled"}
                >
                <label
                  for="${i.context||"card"}-${a.id}-option-${z(o)}"
                  ${h?"":"disabled"}
                  class="quick-add-form__variant-label${h?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${o}</span>
                  <svg aria-label="Tick icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1198_25368)">
                  <path d="M6.90909 11L6.55874 11.3567C6.75324 11.5478 7.06494 11.5478 7.25945 11.3567L6.90909 11ZM14.5 8C14.5 11.5899 11.5899 14.5 8 14.5V15.5C12.1421 15.5 15.5 12.1421 15.5 8H14.5ZM8 14.5C4.41015 14.5 1.5 11.5899 1.5 8H0.5C0.5 12.1421 3.85786 15.5 8 15.5V14.5ZM1.5 8C1.5 4.41015 4.41015 1.5 8 1.5V0.5C3.85786 0.5 0.5 3.85786 0.5 8H1.5ZM8 1.5C11.5899 1.5 14.5 4.41015 14.5 8H15.5C15.5 3.85786 12.1421 0.5 8 0.5V1.5ZM3.64965 8.49958L6.55874 11.3567L7.25945 10.6433L4.35035 7.78613L3.64965 8.49958ZM7.25945 11.3567L12.3504 6.35672L11.6496 5.64328L6.55874 10.6433L7.25945 11.3567Z" fill="currentColor" />
                  </g>
                  <defs>
                  <clipPath id="clip0_1198_25368">
                  <rect width="16" height="16" fill="white"/>
                  </clipPath>
                  </defs>
                  </svg>
                </label>
              </div>
            `}s+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${i.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${r}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(e.name==="Colour"||e.name==="Color"){let r="";for(let g=0;g<Math.min(e.values.length,3);g++){const o=e.values[g],n=a.variants.find(L=>L.option2===o),h=(c=(d=o.swatch)==null?void 0:d.color)==null?void 0:c.rgba,w=(l=o.swatch)==null?void 0:l.image;r+=`
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-color-${z(o)}"
                  name="Color"
                  value="${o}"
                  data-variant-id="${(n==null?void 0:n.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${o.selected?"checked":""}
                >
                <label
                  for="${i.context||"card"}-${a.id}-color-${z(o)}"
                  class="quick-add-form__variant-label--swatch${w?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${o.product_url||""}"
                  data-swatch
                  data-color="${z(o)}"
                  ${h||w?`style="${h?`background-color: rgba(${h}); --swatch-color: rgba(${h});`:""}${w?`background-image: url(${w});`:""}"`:`style="--swatch-color: var(--swatch-color-${z(o)});"`}
                >
                  <span class="visually-hidden">${o}</span>
                </label>
              `}e.values.length>3&&(r+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${e.values.length-3}</span>
                </div>
              `),s+=`
              <div class="quick-add-form__color-swatches">
                ${i.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${r}
              </div>
            `}}return s},p=()=>{const s=a.tags||[],d=s.some(e=>e.includes("badge:"));if(!(C||d))return"";let l="";if(C)l=`
        <div class="product-card__badge badge product-card__badge--sale">
          Save <span>${Math.round((x-k)*100/x)}%</span>
        </div>
      `;else{let e=!1;if(!e){for(const r of s)if(r.includes("badge:use-code-")){l=`<div class="product-card__badge badge product-card__badge--use-code">Use Code ${r.replace("badge:use-code-","").replace(/-/g," ").toUpperCase()}</div>`,e=!0;break}}if(!e&&s.includes("badge:trending")&&(l='<div class="product-card__badge badge product-card__badge--trending">Trending</div>',e=!0),!e&&s.includes("badge:low-in-stock")&&(l='<div class="product-card__badge badge product-card__badge--low-stock">Low in Stock</div>',e=!0),!e){for(const r of s)if(r.includes("badge:custom-")){l=`<div class="product-card__badge badge product-card__badge--custom">${r.replace("badge:custom-","").replace(/-/g," ").toUpperCase()}</div>`,e=!0;break}}!e&&s.includes("badge:coming-soon")&&(l='<div class="product-card__badge badge product-card__badge--coming-soon">Coming Soon</div>',e=!0),!e&&s.includes("badge:sold-out")&&(l='<div class="product-card__badge badge product-card__badge--sold-out">Sold Out</div>',e=!0),!e&&s.includes("badge:pre-order")&&(l='<div class="product-card__badge badge product-card__badge--pre-order">Pre-order</div>',e=!0),!e&&s.includes("badge:most-loved")&&(l='<div class="product-card__badge badge product-card__badge--most-loved">Most Loved</div>',e=!0),!e&&s.includes("badge:best-seller")&&(l='<div class="product-card__badge badge product-card__badge--best-seller">Best Seller</div>',e=!0),!e&&s.includes("badge:new")&&(l='<div class="product-card__badge badge product-card__badge--new">New</div>',e=!0)}return l?`<div class="product-card__badges">${l}</div>`:""},m=()=>`
      <div class="product-card__price-wrapper">
        ${C?`<s class="product-card__price--compare">${t.formatCurrency(x)}</s>`:""}
        <span class="product-card__price--${C?"sale":"regular"}">${t.formatCurrency(k)}</span>
      </div>
    `,y=()=>{if(f==="gallery"&&$>1){let s="";for(let d=0;d<Math.min($,M);d++){const c=_[d];s+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${c.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${s}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(f==="hover"&&$>1){let s="";for(let d=0;d<Math.min($,2);d++){const c=_[d];s+=`<img src="${c.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${s}
        </a>
      `}else{const s=a.featured_image;return`
        <a class="product-card__default-image" href="${b}">
          ${s?`<img src="${s.src}" alt="${a.title}" loading="lazy" placeholder="product">`:'<div class="product-card__placeholder placeholder-svg"></div>'}
        </a>
      `}},u=()=>`
      <button class="product-card__wishlist-button product-card__cta" type="button">
        <svg class="icon icon-heart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.5783 8.50903 2.9987 7.05 2.9987C5.59096 2.9987 4.19169 3.5783 3.16 4.61C2.1283 5.6417 1.5487 7.04097 1.5487 8.5C1.5487 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6053C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.06211 22.0329 6.39467C21.7563 5.72723 21.351 5.1208 20.84 4.61V4.61Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,v=()=>{const s=`
      <div class="product-card__badges-mobile">
        ${p()}
      </div>
    `;return`
      <div class="product-card__meta">
        <p class="product-card__title">${a.title.charAt(0).toUpperCase()+a.title.slice(1).toLowerCase().split(" - ")[0]}</p>
        <div class="product-card__price">
          ${m()}
        </div>
        ${s}
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${p()}
        ${u()}
        ${y()}
        <div class="product-card__ctas">
          <button
            class="product-card__quick-add-button product-card__cta"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||b}"
          >
            <svg class="icon icon-plus" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          ${u()}
        </div>
        <div class="product-card__quick-add-form">
          ${q()}
        </div>
      </div>
      ${v()}
    </product-card>
  `},I=(a,t)=>{var k;const i=((k=window.theme)==null?void 0:k.brandEnvironment)||"cdp";switch(i==="gia"?"iamgia":i){case"iamgia":return T(a,t);case"tigermist":return O(a,t);case"cdp":default:return A(a,t)}},U=(a,t)=>{var _,$,M,f,q;const i=((_=t==null?void 0:t.dataset)==null?void 0:_.sectionId)||"no-results",b=($=t==null?void 0:t.dataset)==null?void 0:$.title,k=(M=t==null?void 0:t.dataset)==null?void 0:M.headingSize,x=(f=t==null?void 0:t.dataset)==null?void 0:f.buttonLabel,C=(q=t==null?void 0:t.dataset)==null?void 0:q.buttonUrl;return{widget:{options:{limit:a,displayFormat:"grid",includeTagalysCSS:!1},render:(p,m)=>{const y=m.props,v=y.helpers.getProducts();if(y.loading===!1)return v.length===0?null:p`
            <${m.templates.title} />
            <${m.templates.productList} />
            <${m.templates.button} />
          `}},title:{render:p=>b?p`
            <div class="product-recommendations__title">
              <h2 class="title inline-richtext ${k}">${b}</h2>
            </div>
          `:p``},productList:{render:(p,m)=>p`
        <slider-component class="slider-component-full-width">
          <${m.templates.products} />
        </slider-component>
      `},products:{render:(p,m)=>{const u=m.props.helpers.getProducts();return p`<ul
          id="Slider-${i}"
          class="results-grid results-grid--default list-inline m-results-grid--2"
        >
          ${u.map((v,s)=>p`<li class="results-grid__tile">
                <${m.templates.product} key=${s} product=${v} />
              </li>`)}
        </ul> `}},product:{options:{productPageUrl(p){return B(p)}},render:(p,m)=>{const y=m.props,u=y.product,v=y.helpers;return p`<div
          class="tagalys-section__slide"
          id="Slide-${u.id}"
          dangerouslySetInnerHTML=${{__html:I(u,v)}}
        />`}},carouselActions:{render:p=>{var m,y,u,v,s,d;return p`
        <div class="slider-buttons">
          <button
            type="button"
            class="slider-button slider-button--prev"
            name="previous"
            aria-label="${(u=(y=(m=window.theme)==null?void 0:m.strings)==null?void 0:y.accessibility)==null?void 0:u.previousSlide}"
            aria-controls="Slider-${i}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="slider-button slider-button--next"
            name="next"
            aria-label="${(d=(s=(v=window.theme)==null?void 0:v.strings)==null?void 0:s.accessibility)==null?void 0:d.nextSlide}"
            aria-controls="Slider-${i}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
        </div>
      `}},button:{render:p=>x&&C?p`
            <div class="product-recommendations__button">
              <a href="${C}" class="button button--secondary">${x}</a>
            </div>
          `:p``}}};export{B as c,I as r,U as t};
